const pad2 = (value) => String(value).padStart(2, "0");

const hasExplicitTime = (value) => {
  if (!value) return false;

  const text = String(value).trim();

  // ISO datetime: 2026-08-28T12:05:00Z
  if (text.includes("T")) return true;

  // Space datetime: 2026-08-28 12:05:00
  if (/^\d{4}-\d{1,2}-\d{1,2}\s+\d{1,2}:\d{2}/.test(text)) {
    return true;
  }

  // DD/MM/YYYY HH:mm or DD-MM-YYYY HH:mm
  if (/^\d{1,2}[/-]\d{1,2}[/-]\d{4}\s+\d{1,2}:\d{2}/.test(text)) {
    return true;
  }

  return false;
};

export const parseNCRDateTime = (value) => {
  if (!value) return null;

  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }

  const text = String(value).trim();
  if (!text) return null;

  // DD/MM/YYYY or DD-MM-YYYY with optional HH:mm AM/PM
  const dmyMatch = text.match(
    /^(\d{1,2})[/-](\d{1,2})[/-](\d{4})(?:[\s,T]+(\d{1,2}):(\d{2})(?::(\d{2}))?\s*(AM|PM|am|pm)?)?$/
  );

  if (dmyMatch) {
    const [, dd, mm, yyyy, hhRaw, minRaw, secRaw, meridiemRaw] = dmyMatch;

    let hours = hhRaw ? Number(hhRaw) : 0;
    const minutes = minRaw ? Number(minRaw) : 0;
    const seconds = secRaw ? Number(secRaw) : 0;

    if (meridiemRaw) {
      const meridiem = meridiemRaw.toUpperCase();

      if (meridiem === "PM" && hours < 12) {
        hours += 12;
      }

      if (meridiem === "AM" && hours === 12) {
        hours = 0;
      }
    }

    const date = new Date(
      Number(yyyy),
      Number(mm) - 1,
      Number(dd),
      hours,
      minutes,
      seconds
    );

    return Number.isNaN(date.getTime()) ? null : date;
  }

  // YYYY-MM-DD date only: parse as local date, not UTC
  const ymdOnlyMatch = text.match(/^(\d{4})-(\d{1,2})-(\d{1,2})$/);

  if (ymdOnlyMatch) {
    const [, yyyy, mm, dd] = ymdOnlyMatch;
    const date = new Date(Number(yyyy), Number(mm) - 1, Number(dd));
    return Number.isNaN(date.getTime()) ? null : date;
  }

  // ISO datetime or any JS-supported datetime
  const parsed = new Date(text);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

export const formatNCRDate = (value, fallback = "-") => {
  if (!value) return fallback;

  const date = parseNCRDateTime(value);
  if (!date) return fallback;

  return [
    pad2(date.getDate()),
    pad2(date.getMonth() + 1),
    date.getFullYear(),
  ].join("/");
};

export const formatNCRDateTime = (value, fallback = "-") => {
  if (!value) return fallback;

  const date = parseNCRDateTime(value);
  if (!date) return fallback;

  let hours = date.getHours();
  const minutes = pad2(date.getMinutes());
  const meridiem = hours >= 12 ? "PM" : "AM";

  hours = hours % 12;
  if (hours === 0) hours = 12;

  return `${formatNCRDate(date, fallback)} ${pad2(hours)}:${minutes} ${meridiem}`;
};

export const formatNCRDateOrDateTime = (value, fallback = "-") => {
  if (!value) return fallback;

  if (hasExplicitTime(value)) {
    return formatNCRDateTime(value, fallback);
  }

  return formatNCRDate(value, fallback);
};
